import { AddressMonitoringData } from '@/redux/models';

export const addressHistoryDemoData: AddressMonitoringData = {
  result: true,
  pageLimit: 10,
  totalCount: 5,
  items: [
    {
      id: 1,
      address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      asset: 'ETH',
      riskscore: 22,
      next_check_time: '2024-06-12 10:41:57',
      status: 0,
      tmacnt_id: 1,
      create: '2024-06-12 10:41:57',
      valid_until: '2024-06-12 10:41:57',
      type: 0,
      has_blacklist_flag: false,
    },
    {
      id: 2,
      address: '0xdef1c0ded9bec7f1a1670819833240f027b25eff',
      asset: 'AVAX',
      riskscore: 77,
      next_check_time: '2024-06-12 10:41:57',
      status: 5,
      tmacnt_id: 2,
      create: '2024-06-12 10:41:57',
      valid_until: '2024-06-12 10:41:57',
      type: 0,
      has_blacklist_flag: false,
    },
    {
      id: 3,
      address: '0x4de23f3f0fb3318287378adbde030cf61714b2f3',
      asset: 'BSC',
      riskscore: 0,
      next_check_time: '2024-06-12 10:41:57',
      status: 5,
      tmacnt_id: 3,
      create: '2024-06-12 10:41:57',
      valid_until: '2024-06-12 10:41:57',
      type: 0,
      has_blacklist_flag: true,
    },
    {
      id: 4,
      address: '3HQBsRNJcnzk4kcGxMabFMqD6Ud23T5eUd',
      asset: 'BTC',
      riskscore: 12,
      next_check_time: '2024-06-12 10:41:57',
      status: 0,
      tmacnt_id: 4,
      create: '2024-06-12 10:41:57',
      valid_until: '2024-06-12 10:41:57',
      type: 0,
      has_blacklist_flag: false,
    },
    {
      id: 5,
      address: 'TDqSquXBgUCLYvYC4XZgrprLK589dkhSCf',
      asset: 'TRX',
      riskscore: 48,
      next_check_time: '2024-06-12 10:41:57',
      status: 0,
      tmacnt_id: 5,
      create: '2024-06-12 10:41:57',
      valid_until: '2024-06-12 10:41:57',
      type: 0,
      has_blacklist_flag: false,
    },
  ],
};
